/**
 * Q1 option labels, exactly as stored in the PrimaryInterests table.
 *
 * These strings are compared character-for-character against PrimaryInterest.Interest
 * coming back from GET marketing/primary-interests. There is no stable key column on
 * that table, so renaming an option in the database silently disables its Q2 step and
 * its slide deck with no error. Rename here and in the database together.
 */
export const INTEREST = {
  CREATOR: 'Creator / Solopreneur',
  LD_HR: 'L&D / HR / Workplace Training',
  EDUCATION: 'Education / Academic Institution',
  CUSTOMER_SUCCESS: 'Customer Success & Product Training',
  MARKETING_COMMUNITY: 'Marketing & Community',
  OTHER: 'Other',
}

/**
 * Interests that show a Q2 step. Education and Other go straight to the free-text
 * question instead, because their goals are too varied to enumerate usefully.
 */
const INTERESTS_WITH_Q2 = [
  INTEREST.CREATOR,
  INTEREST.LD_HR,
  INTEREST.CUSTOMER_SUCCESS,
  INTEREST.MARKETING_COMMUNITY,
]

export const hasDeliveryStep = interest => INTERESTS_WITH_Q2.includes(interest)
